import ClientServiceService from "../../../services/ClientServiceService";
import M from "materialize-css";
import Messages from "../../../utils/messages";
import Modal from "@/components/Modal";
export default {
  name: "ClientService",
  data: () => ({
    serviceId: 0,
    carWashIsReadOnly: true,
    carRegNumber: null,
    serviceDisabled: true,
    serviceList: [],
    operatorHint: "",
    otpCode: null,
    policyId: null,
    modalData: {
      show: false,
      availableActionList: [],
      noAction: false,
    },
  }),
  components: {
    Modal,
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const user = JSON.parse(localStorage.getItem("User"));
      this.carWashID = user.carWash.id;
      ClientServiceService.GetServicableLimitList(this.carWashID).then(
        (res) => {
          console.log(res);
          this.serviceList = res;
          if (res.length == 1) {
            this.serviceDisabled = false;
            this.serviceId = res[0].id;
          } else {
            this.serviceDisabled = false;
            this.carWashIsReadOnly = false;
            this.serviceList.unshift({ id: 0, description: "აირჩიეთ სერვისი" });
          }
          this.$nextTick(function () {
            M.FormSelect.init(this.$refs.ServiceRef, {});
            M.updateTextFields();
          });
        }
      );
    },
    CheckCar() {
      if (this.serviceId == 0 || !this.carRegNumber) {
        this.$message(Messages["CarCheckFillAllFields"]);
        return;
      }
      ClientServiceService.CheckCar(this.carRegNumber, this.serviceId).then(
        (res) => {
          if (res.status == 0 || res.status == 9) {
            console.log(res);
            this.operatorHint = res.operatorHint;
            this.modalData.show = true;
            this.modalData.noAction = res.status == 9;
            this.modalData.availableActionList = [];
            if (res.status == 0) {
              this.policyId = res.model.policyID;
              let obj = {
                name: "დადასტურება",
                class: "btn",
                funq: this.AprooveCode,
              };
              this.modalData.availableActionList.push(obj);
            }
            let obj2 = {
              name: "დახურვა",
              funq: this.Close,
            };
            this.modalData.availableActionList.push(obj2);
          } else {
            let ErrorCode = "CarCheck" + res.statusDesc;
            this.$message(Messages[ErrorCode]);
          }
        }
      );
    },
    AprooveCode() {
      ClientServiceService.AprooveWachingCode(this.policyId, this.otpCode).then(
        (res) => {
          let ErrorCode = "CarCheck" + res.statusDesc;
          alert(Messages[ErrorCode]);
          if (res.statusCode == 0) {
            this.Finalize();
          }
        }
      );
    },
    Close() {
      this.modalData.show = false;
    },
    Finalize() {
      this.carRegNumber = null;
      this.phoneNumber = null;
      this.otpCode = null;
      this.policyId = null;
      this.modalData.show = false;
      this.modalData.availableActionList = [];
    },
  },
};
